import Index from '@/views/zones/index'
import Form from '@/views/zones/form'

import PostalCodeIndex from '@/views/service-postal-codes/index'
import PostalCodeForm from '@/views/service-postal-codes/form'
import PostalCodeImport from '@/views/service-postal-codes/import'

const model = 'Zone'
export default [
  {
    path: '/zones',
    name: 'zones',
    component: Index,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/zones/new',
    name: 'newZone',
    component: Form,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  },
  {
    path: '/zones/:id/edit',
    name: 'editZone',
    component: Form,
    meta: { requiresAuth: true, auth: { model, permission: 'update' } }
  },
  {
    path: '/zones/:zoneId/zone-postal-codes',
    name: 'zonePostalCodes',
    component: PostalCodeIndex,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/zones/:zoneId/zone-postal-codes/new',
    name: 'newZonePostalCode',
    component: PostalCodeForm,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  },
  {
    path: '/zones/:zoneId/zone-postal-codes/import',
    name: 'importZonePostalCodes',
    component: PostalCodeImport,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  },
  {
    path: '/zones/:zoneId/zone-postal-codes/:id/edit',
    name: 'editZonePostalCode',
    component: PostalCodeForm,
    meta: { requiresAuth: true, auth: { model, permission: 'update' } }
  }
]